import "core-js/modules/es.object.keys.js";
import AuthorImg from "./AuthorImg";
export default {
  name: "invitationItem",
  components: {
    AuthorImg: AuthorImg
  },
  props: {
    item: {
      type: Object,
      default: {
        applicationNum: "3",
        coverImgUrl: "/d/file/custom/30018/file/202301/1673339655419736.png",
        endTime: "2023-02-11T11:43:55Z",
        goodsNum: "10",
        goodsPrice: "10",
        id: "5",
        invitationNum: "0",
        inviteNum: "10",
        isMe: "0",
        startTime: "2023-01-11T11:43:55Z",
        status: "1",
        title: "鹅鹅鹅鹅哈哈哈哈"
      }
    }
  },
  computed: {
    notEmpty: function notEmpty() {
      return Object.keys(this.item).length;
    },
    statusText: function statusText() {
      return ["已取消", "未开始", "进行中"][this.item.status - 0 + 1];
    }
  }
};